import api from './api';
import { PatternContainer } from '../types';

class PatternContainerService {
  async getContainers(parentId: number | null = null): Promise<PatternContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/pattern-containers/', { params });
    // Handle paginated response
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getAllContainers(): Promise<PatternContainer[]> {
    const response = await api.get('/pattern-containers/all/');
    return response.data;
  }

  async getContainer(id: number): Promise<PatternContainer> {
    const response = await api.get(`/pattern-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(id: number): Promise<{ containers: PatternContainer[], patterns: any[] }> {
    const response = await api.get(`/pattern-containers/${id}/contents/`);
    return response.data;
  }

  async createContainer(data: Partial<PatternContainer>): Promise<PatternContainer> {
    const response = await api.post('/pattern-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<PatternContainer>): Promise<PatternContainer> {
    const response = await api.patch(`/pattern-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/pattern-containers/${id}/`);
  }

  async reorderContainers(items: { id: number; order: number }[], parent?: number | null): Promise<void> {
    await api.post('/pattern-containers/reorder/', { items, parent: parent ?? null });
  }
}

const patternContainerService = new PatternContainerService();
export default patternContainerService;